import styled from 'styled-components';

const Wrapper = styled.span`
  &:before {
    content: ':';
    padding: 0 4px;
    display: inline-block;
  }
`;

// 冒号
export default function Colon({ className }) {
  return <Wrapper className={className}></Wrapper>;
}
